<template>
  <div>
    <div class="parent">
      <v-card>
        <v-card-title class="info-title">
          <div class="text-center text-padding">
            {{ item.YearMonth }}
          </div>
        </v-card-title>
        <div>
          <app-row
            title="گزارش فرد:"
            :value="`${item.Fard_Report} 
          ${ezam.TarhType == 1 ? 'روز' : 'ساعت'}`"
          />
          <app-row
            title="تایید ستاد:"
            :value="`${item.Setad_Report} 
          ${ezam.TarhType == 1 ? 'روز' : 'ساعت'}`"
          />
        </div>
        <div style="padding: 15px">
          <v-row align="center">
            <v-col class="d-flex">
              <b>توضيحات فرد:</b>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col class="d-flex content">
              {{ item.Des_Fard }}
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col class="d-flex">
              <b>توضيحات ستاد:</b>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col class="d-flex content">
              {{ item.Des_Setad }}
            </v-col>
          </v-row>
          <div style="padding: 5px"></div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: ["item", "index", "ezam"],
  computed: {},
  components: {
    appRow: DetailRow,
  },
  methods: {
    getState(state) {
      switch (state) {
        case 0:
          return "نیازمند تایید";
        case 1:
          return "تایید شده";
        case 2:
          return "رد شده";
      }
    },
  },
};
</script>
<style scoped>
.register {
  margin: 20px 20px 0 20px !important;
}
</style>
